import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import ReactPlayer from 'react-player';
import $ from 'jquery';
import classnames from 'classnames';
import Loader from 'views/ui/loaders/three_dots';
import './index.scss';

class LazyImage extends React.Component {
  constructor(props) {
    super(props);
    const { activate } = this.props;
    this.state = {
      activated: activate,
      loaded: this._imageIsLoaded(),
      isPlayerPause: false,
    };
    this.imgRef = createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { activated } = this.state;
    if (!activated && nextProps.activate) {
      this.setState({ activated: true });
    }
  }

  componentDidUpdate() {
    const { activated, loaded } = this.state;
    const { isLazyPlayerVisible, startTime } = this.props;
    if (activated && !loaded) {
      this._syncLoadedState();
    }
  }

  _syncLoadedState = () => {
    if (!this._imageIsLoaded()) {
      $(this.imgRef?.current).load(() => {
        this.setState({ loaded: true });
      });
    } else {
      this.setState({ loaded: true });
    }
  };

  _imageIsLoaded = () => {
    const img = this.imgRef?.current;
    return !!(img && (img.complete || img.naturalWidth > 0));
  };

  _renderLoader = () => {
    return <Loader className="centered dot-10 light" />;
  };

  _renderImage = () => {
    const { src } = this.props;
    return <img ref={this.imgRef} src={src} alt="Experience" />;
  };

  _renderMedia = () => {
    const {
      src,
      isLazyPlayerVisible,
      isBrowserFocused,
      handleVideoProgress,
      playerRef,
    } = this.props;
    const { isPlayerPause } = this.state;
    return (
      <ReactPlayer
        url={src.media_link}
        playing={isLazyPlayerVisible && !isPlayerPause && isBrowserFocused}
        controls
        muted
        width="100%"
        height="100%"
        ref={playerRef}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          transition: 'opacity 0.5s',
        }}
        onPause={() => {
          if (isLazyPlayerVisible && isBrowserFocused) {
            this.setState({ isPlayerPause: true });
          }
        }}
        onPlay={() => this.setState({ isPlayerPause: false })}
        onProgress={handleVideoProgress}
      />
    );
  };
  render() {
    const { activated, loaded } = this.state;
    const { className, position, totalImages, src } = this.props;
    const classNames = classnames('LazyImage', className);

    return (
      <div
        aria-label={`${position} of ${totalImages}`}
        className={classNames}
        role="group"
      >
        {loaded ? null : this._renderLoader()}
        {activated && !src.media ? this._renderImage() : null}
        {src.media ? this._renderMedia() : null}
      </div>
    );
  }
}

LazyImage.displayName = 'LazyImage';

LazyImage.propTypes = {
  activate: PropTypes.bool,
  className: PropTypes.string,
  position: PropTypes.number,
  src: PropTypes.string,
  totalImages: PropTypes.number,
  isLazyPlayerVisible: PropTypes.bool,
  isBrowserFocused: PropTypes.bool,
};

export default LazyImage;
